import TourEnthusiast from '../img/experience/1.jpg';

const TourWithAnEnthusiasticLocal = {
	id: 1, img: TourEnthusiast, permalink: "tour-with-an-enthusiastic-local", title: "Tour with an Enthusiastic Local!", city: "Entertaintment-Vancouver", location: "Vancouver, Canada", star: 4.1, cost: 72
};
export default TourWithAnEnthusiasticLocal;